module.exports = __webpack_public_path__ + "img/payout.64309d56.svg";